import { useEffect } from "react";

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
  schemaData?: Record<string, unknown>;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl = "https://mangguoshipin.com",
  ogImage = "https://readdy.ai/api/search-image?query=Warm%20cinematic%20home%20theater%20with%20soft%20golden%20amber%20lighting%20cozy%20atmosphere%20elegant%20modern%20interior%20design%20movie%20night%20vibe%20mango%20color%20palette&width=1200&height=630&seq=og-default&orientation=landscape",
  ogType = "website",
  schemaData,
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, property = false) => {
      const attr = property ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", description);
    setMeta("keywords", keywords);
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:image", ogImage, true);
    setMeta("og:type", ogType, true);
    setMeta("og:url", canonicalUrl, true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", ogImage);

    const existingLink = document.querySelector('link[rel="canonical"]');
    if (existingLink) {
      existingLink.setAttribute("href", canonicalUrl);
    } else {
      const link = document.createElement("link");
      link.rel = "canonical";
      link.href = canonicalUrl;
      document.head.appendChild(link);
    }

    let schemaScript = document.getElementById("schema-ld");
    if (!schemaScript && schemaData) {
      schemaScript = document.createElement("script");
      schemaScript.id = "schema-ld";
      schemaScript.type = "application/ld+json";
      document.head.appendChild(schemaScript);
    }
    if (schemaScript && schemaData) {
      schemaScript.textContent = JSON.stringify(schemaData);
    }
  }, [title, description, keywords, canonicalUrl, ogImage, ogType, schemaData]);

  return null;
}